import React, { useEffect, useState } from 'react';
import { pathHome } from '../../path';
import styles from './ingredients-page.module.css';
import { Link } from 'react-router-dom';
import AddIngredients from '../../components/AddIngredients/AddIngredients';
import { addDocBd, deleteDocBd, getDocsOrderByBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import CopyBtn from '../../elemets/CopyBtn/CopyBtn';
import DownloadBtn from '../../elemets/DownloadBtn/DownloadBtn';
import { getObjectIngredient } from '../../helperProject';
import { bodyScrollOverflowAuto, bodyScrollOverflowHidden, isArraysIncludes } from '../../helper';

export default function IngredientsPage() {
  const [popupAddIngredients, setPopupAddIngredients] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);
  const [restartPage, setRestartPage] = useState(false);

  const [ingredientsArray, setIngredientsArray] = useState([]);
  const [ingredientEdit, setIngredientEdit] = useState(null);

  const [products, setProducts] = useState([]);

  useEffect(() => {
    setLoaderPage(true);
    const getProducts = async () => {
      const ingredients = await getDocsOrderByBd('ingredients', 'textIngredientDefault');
      const products = await getDocsOrderByBd('products', 'productText');
      if (ingredients) {
        setIngredientsArray(ingredients);
      }
      if (products) {
        setProducts(products);
      }
      setLoaderPage(false);
    };
    getProducts();
    return () => {
      bodyScrollOverflowAuto();
    };
  }, [restartPage]);

  const deleteIngredient = async (id) => {
    setLoaderPage(true);
    const isDeleteIngredient = window.confirm('Видалити інгридієнт?');
    if (isDeleteIngredient) {
      const ifDeleteIngredient = await deleteDocBd('ingredients', id);
      if (ifDeleteIngredient) {
        const newIngredientsArray = ingredientsArray.filter((product) => product.id != id);
        setIngredientsArray(newIngredientsArray);
        alert('Видалено успішно!');
      } else {
        alert('Не вдолося видалити!');
      }
    }
    setLoaderPage(false);
  };

  const editIngredient = (ingredient) => {
    setIngredientEdit(ingredient);
    setPopupAddIngredients(true);
    bodyScrollOverflowHidden();
  };

  const renderIngredients = (ingredients) => {
    return ingredients.map((item) => {
      return (
        <div key={item.id} className={styles.ingredient_block}>
          <div
            onClick={() => editIngredient(item)}
            className={
              item.newIngredient
                ? styles.ingredient_info + ' ' + styles.ingredient_info_new
                : styles.ingredient_info
            }>
            {item.textIngredientDefault +
              ' ' +
              '(' +
              item.unitIngredient +
              ')' +
              ' (' +
              item.unitBasket +
              ')'}
          </div>
          <div
            className={styles.delete_ingredient_wrapper}
            onClick={() => deleteIngredient(item.id)}>
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 3H18V18C18 19.1046 17.1046 20 16 20H5C3.89543 20 3 19.1046 3 18V3Z"
                fill="#FF5C5E"></path>
              <rect width="21" height="2" rx="1" fill="#FF5C5E"></rect>
            </svg>
          </div>
        </div>
      );
    });
  };

  // ==========================================================================================
  // Перевіряє чи вірний формат даних які будем завантажувти
  const verificationArrey = (arrayВownloadKeys, arrayIngredientKeys) => {
    // console.log('arrayВownloadKeys === ', arrayВownloadKeys);
    // console.log('arrayIngredientKeys === ', arrayIngredientKeys);

    let isVerification = 0;
    arrayВownloadKeys.forEach((value) => {
      const isIncludes = isArraysIncludes([...arrayIngredientKeys, 'newIngredient'], value);
      if (isIncludes) {
        isVerification++;
      }
    });
    if (arrayВownloadKeys.length === isVerification) {
      return true;
    }
    return false;
  };

  // // Додає дані в базу данних
  const addDocs = (dataString) => {
    const data = JSON.parse(dataString);

    setLoaderPage(true);

    let indexValue = 0;

    const addDoc = async () => {
      const isAddDoc = await addDocBd('ingredients', data[indexValue].id, {
        ...data[indexValue],
        newIngredient: false,
      });
      if (isAddDoc) {
        indexValue++;
        if (data.length > indexValue) {
          addDoc();
        }
        if (data.length === indexValue) {
          setLoaderPage(false);
          setRestartPage(!restartPage);
          alert('Додано успішно!');
        }
      } else {
        if (indexValue === 0) {
          alert('Не вдалось додати дані!');
        }
        if (indexValue > 0) {
          alert('Не всі дані були додані');
        }
        setRestartPage(!restartPage);
        setLoaderPage(false);
      }
    };

    if (data && data.length) {
      const isVerification = verificationArrey(
        Object.keys(data[0]),
        Object.keys(getObjectIngredient()),
      );

      if (!isVerification) {
        alert('Не вірний формат даних!');
        setLoaderPage(false);
        return;
      }
      addDoc();
    } else {
      setLoaderPage(false);
    }
  };

  //Додаэ даны в буфер обмыну
  const writeData = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data))
      .then(() => {
        alert('Скопійовано');
      })
      .catch(() => {
        alert('Не вдалося скопіювати!');
      });
  };

  // Отримуэ даны з буфера обмыну
  const readData = () => {
    navigator.clipboard
      .readText()
      .then((data) => {
        addDocs(data);
      })
      .catch(() => {
        alert('Не вдалося завантажити! (Код ошибки: 0001)');
      });
  };

  const downloadData = () => {
    let isDownloadData = window.confirm('Завантажити дані?');

    if (isDownloadData) {
      readData();
    }
  };
  // ==========================================================================================

  const showAddIngredients = () => {
    setPopupAddIngredients(true);
    bodyScrollOverflowHidden();
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <Link className={styles.header_link} to={`/${pathHome}/home`}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9L11.25 0.339745V17.6603L0 9Z" fill="white" />
          </svg>
          Головна
        </Link>
        <div>{ingredientsArray.length} шт.</div>
        <svg
          onClick={() => showAddIngredients(true)}
          className={styles.interaction_item}
          width="35"
          height="36"
          viewBox="0 0 35 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
          <path
            d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={styles.content_wrapper}>
        <div className={'df gap_20 mb_10'}>
          {ingredientsArray.length ? (
            <div onClick={() => writeData(ingredientsArray)}>
              <CopyBtn textBtn="Копіювати все" />
            </div>
          ) : (
            ''
          )}

          <div onClick={() => downloadData()}>
            <DownloadBtn textBtn="Завантажити" />
          </div>
        </div>
        {ingredientsArray.length ? (
          renderIngredients(ingredientsArray)
        ) : loaderPage ? (
          <div>Загрузка...</div>
        ) : (
          <div>Пусто:)</div>
        )}
      </div>
      {popupAddIngredients && (
        <AddIngredients
          setPopup={setPopupAddIngredients}
          products={products}
          ingredientsArray={ingredientsArray}
          setIngredientsArray={setIngredientsArray}
          ingredientEdit={ingredientEdit}
          setIngredientEdit={setIngredientEdit}
        />
      )}
      {loaderPage && <LoaderPage />}
    </>
  );
}
